import { institutionTypeDomaine, roles } from "../../../utils/constants";
import { useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { userHasLevel } from "../../../engine/AuthRoute";
import {
  mainTypesPrestation,
  typesPrestation,
} from "../../../utils/typesPrestation";

export const institutionsDetailinputs = ({ institution, user }) => {
  const {
    name,
    secondName,
    type,
    archived,
    principal,
    mainType,
    tags,
    interventionLocation,
  } = institution;
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom 1",
          name: "name",
          value: name,
          required: true,
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: "Nom 2",
          name: "secondName",
          value: secondName,
          type: "input",
          col: 24,
        },
        {
          value: mainType,
          label: "Domaine principal",
          name: "mainType",
          showSearch: true,
          type: "select",
          selectContent: mainTypesPrestation,
          selectType: "group",
          col: 24,
        },
        {
          value: tags,
          label: "Tags",
          name: "tags",
          multiple: "true",
          disabled: true,
          showSearch: true,
          type: "select-add",
          selectContent: [],
          col: 24,
        },
        {
          value: interventionLocation,
          label: "Adresse d'intervention par défaut",
          name: "interventionLocation",
          type: "google-adress",
          col: 24,
        },
        {
          label: "Mandant global",
          name: "principal",
          value: principal?._id,
          allowClear: true,
          type: "dynamic-select",
          endPoint: routes.principals().path,
          disabled: !userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? "Créer l'institution" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
